import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Title, Banner } from "@similarweb/ui-components";

import { SearchContainer } from "app/pages/conversion/conversionTableContainer/StyledComponents";
import { InfoIcon } from "pro-features/components/BoxTitle/src/BoxTitle";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const WebsiteAnalysisGeoContainer = styled.div`
    padding: -4px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    align-items: center;
`;

export const BoxContainer: any = styled(Box)`
    width: 100%;
    max-width: 1368px;
    height: auto;
    border-radius: 6px 6px 0px 0px;
`;

export const TitleContainer = styled(FlexRow)`
    box-sizing: border-box;
    padding: 24px 24px 12px 24px;
    justify-content: space-between;
`;

export const StyledHeaderTitle = styled(Title)`
    font-size: 20px;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

export const ButtonsContainer = styled(FlexRow)`
    margin-right: 0px;
    align-items: center;
`;

export const TableTopContainer = styled(SearchContainer)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .SearchInput-container {
        width: 100%;

        > div:first-child {
            top: 13px;
        }

        > .SearchInput {
            height: 48px;
        }
    }
`;

export const StyledCountriesPromoBannerWrapper = styled.div`
    margin-bottom: 40px;
`;

export const ButtonContainer = styled.div`
    margin-right: 16px;

    .excel-button-wrapper {
        bottom: 0px;
    }
`;

export const GeoMapRootContainer = styled.div`
    display: flex;
    padding: 24px;
    justify-content: center;
    flex-direction: column;
`;

export const GeoMapContainer = styled.div`
    height: 400px;
    width: 100%;
    flex-shrink: 0;
`;

export const LoaderContainer = styled.div`
    display: flex;
    position: relative;
    height: 400px;
    flex-shrink: 0;
    width: calc(100% - 0px);
`;

export const StyledSwitchContainer = styled.div`
    display: flex;
    color: ${colorsPalettes.carbon[300]};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

export const BannerTitle = styled.div`
    font-family: Roboto;
    color: ${colorsPalettes.carbon[500]};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
`;

export const StyledBanner = styled(Banner)`
    background-color: ${colorsPalettes.sky[100]};
`;
